import React from 'react';

import Header from '../Component/Header';
import Footer from '../Component/Footer';

const ExpertsDtl = () => {
  return (
    <>
      <Header />


<main class="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 text-white">
    <div class="container mx-auto px-2 md:px-4 py-2 md:py-4 flex justify-between items-center">
        <button
            class="justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-10 flex items-center text-slate-300 hover:text-white hover:bg-white/5 p-1 md:p-2"
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-left mr-1 h-4 w-4">
                <path d="m12 19-7-7 7-7"></path>
                <path d="M19 12H5"></path>
            </svg>
            <span class="text-sm">Back</span>
        </button>
    </div>
    <div class="fixed top-20 left-10 w-32 h-32 rounded-full bg-primary/10 blur-3xl pointer-events-none"></div>
    <div class="fixed bottom-20 right-10 w-40 h-40 rounded-full bg-indigo-500/10 blur-3xl pointer-events-none"></div>
    <div class="fixed top-1/3 right-1/4 w-24 h-24 rounded-full bg-pink-500/10 blur-3xl pointer-events-none"></div>
    <div className="container mx-auto px-2 md:px-4 pt-2 md:pt-8 pb-20 md:pb-24">
  <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-8">
    <div className="hidden lg:block lg:col-span-4 xl:col-span-3">
      <div className="sticky top-8">
        <div className="bg-slate-800/50 backdrop-blur-lg rounded-3xl overflow-hidden border border-slate-700/50 shadow-xl">
          <div className="relative">
            <div className="relative h-64 md:h-96 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-b from-primary/20 to-slate-900/90" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative w-32 h-32 md:w-64 md:h-64">
                  <div className="absolute -inset-1 bg-gradient-to-br from-primary via-indigo-500 to-purple-600 rounded-full blur-sm opacity-70" />
                  <div className="absolute inset-0 rounded-full overflow-hidden border-2 border-white/20">
                    <img
                      alt="Ravish Jha"
                      decoding="async"
                      data-nimg="fill"
                      className="object-cover"
                      style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        inset: 0,
                        color: "transparent"
                      }}
                      src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/member-profile-1-Qd5JOMBYLc4AZ6oNEzdBL9WGqL2r4L.jpg"
                    />
                  </div>
                  <div className="absolute -bottom-2 -right-2 bg-primary text-white text-sm font-bold rounded-full h-10 w-10 flex items-center justify-center border-2 border-slate-800 shadow-lg">
                    4.9
                  </div>
                </div>
              </div>
            </div>
            <div className="p-4 md:p-6 text-center">
              <h1 className="text-xl md:text-2xl font-bold text-white mb-1">
                Ravish Jha
              </h1>
              <div className="flex items-center justify-center gap-1 text-slate-300 mb-2 md:mb-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-map-pin h-3 w-3 md:h-4 md:w-4 text-primary"
                >
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                  <circle cx={12} cy={10} r={3} />
                </svg>
                <span className="text-sm md:text-base">Delhi, India</span>
              </div>
              <div className="flex items-center justify-center gap-1 text-amber-400 mb-3 md:mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-slate-700"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <span className="text-xs md:text-sm text-slate-300 ml-1">
                  (87)
                </span>
              </div>
              <div className="relative mb-6">
                <div className="flex overflow-x-auto scrollbar-hide gap-2 py-1 scroll-smooth">
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 hover:bg-slate-700 text-white border-slate-600 whitespace-nowrap flex-shrink-0">
                    Historical Tours
                  </div>
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 hover:bg-slate-700 text-white border-slate-600 whitespace-nowrap flex-shrink-0">
                    Food Experiences
                  </div>
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 hover:bg-slate-700 text-white border-slate-600 whitespace-nowrap flex-shrink-0">
                    Cultural Immersion
                  </div>
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 hover:bg-slate-700 text-white border-slate-600 whitespace-nowrap flex-shrink-0">
                    Photography
                  </div>
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 hover:bg-slate-700 text-white border-slate-600 whitespace-nowrap flex-shrink-0">
                    Budget Travel
                  </div>
                </div>
                <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-slate-800/90 to-transparent pointer-events-none flex items-center justify-end pr-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-chevron-right h-4 w-4 text-white/60"
                  >
                    <path d="m9 18 6-6-6-6" />
                  </svg>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3 mb-6">
                <a target="_blank" href="https://wa.me/918920866123" className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 bg-primary text-white hover:bg-primary/90 rounded-xl">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-calendar mr-2 h-4 w-4"
                  >
                    <path d="M8 2v4" />
                    <path d="M16 2v4" />
                    <rect width={18} height={18} x={3} y={4} rx={2} />
                    <path d="M3 10h18" />
                  </svg>
                  Book Now
                </a>
                <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border  hover:text-accent-foreground h-10 px-4 py-2 border-slate-600 hover:bg-white/5 rounded-xl">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-message-circle mr-2 h-4 w-4"
                  >
                    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
                  </svg>
                  Message
                </button>
              </div>
              <div className="flex justify-center gap-3 mb-6">
                <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 w-10 rounded-full text-slate-400 hover:text-white hover:bg-white/5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-heart h-5 w-5 "
                  >
                    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                  </svg>
                </button>
                <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 w-10 rounded-full text-slate-400 hover:text-white hover:bg-white/5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-bookmark h-5 w-5 "
                  >
                    <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" />
                  </svg>
                </button>
                <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 w-10 rounded-full text-slate-400 hover:text-white hover:bg-white/5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-share2 h-5 w-5"
                  >
                    <circle cx={18} cy={5} r={3} />
                    <circle cx={6} cy={12} r={3} />
                    <circle cx={18} cy={19} r={3} />
                    <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
                    <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
                  </svg>
                </button>
              </div>
              <div className="border-t border-slate-700/50 pt-6">
                <div className="grid grid-cols-2 gap-4">
                  <div className="text-center">
                    <div className="text-xl font-bold text-primary">50+</div>
                    <div className="text-xs text-slate-400">Countries</div>
                  </div>
                  <div className="text-center">
                    <div className="text-xl font-bold text-primary">4+</div>
                    <div className="text-xs text-slate-400">Years</div>
                  </div>
                  <div className="text-center">
                    <div className="text-xl font-bold text-primary">120+</div>
                    <div className="text-xs text-slate-400">Tours</div>
                  </div>
                  <div className="text-center">
                    <div className="text-xl font-bold text-primary">200+</div>
                    <div className="text-xs text-slate-400">Clients</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="px-6 pb-6">
            <div className="border-t border-slate-700/50 pt-6">
              <h3 className="font-semibold text-white mb-3 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-languages h-4 w-4 text-primary mr-2"
                >
                  <path d="m5 8 6 6" />
                  <path d="m4 14 6-6 2-3" />
                  <path d="M2 5h12" />
                  <path d="M7 2h1" />
                  <path d="m22 22-5-10-5 10" />
                  <path d="M14 18h6" />
                </svg>
                Languages
              </h3>
              <div className="flex flex-wrap gap-2">
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600">
                  English
                </div>
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600">
                  Hindi
                </div>
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600">
                  Punjabi
                </div>
              </div>
            </div>
          </div>
          <div className="px-6 pb-6">
            <div className="border-t border-slate-700/50 pt-6">
              <h3 className="font-semibold text-white mb-3 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-globe h-4 w-4 text-primary mr-2"
                >
                  <circle cx={12} cy={12} r={10} />
                  <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
                  <path d="M2 12h20" />
                </svg>
                Connect
              </h3>
              <div className="flex justify-center gap-3">
                <a
                  href="https://instagram.com/ravish"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 w-10 rounded-full bg-gradient-to-br from-purple-600 to-pink-500 text-white hover:opacity-90">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-instagram h-5 w-5"
                    >
                      <rect width={20} height={20} x={2} y={2} rx={5} ry={5} />
                      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
                    </svg>
                  </button>
                </a>
                <a
                  href="https://facebook.com/ravish"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 w-10 rounded-full bg-blue-600 text-white hover:opacity-90">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-facebook h-5 w-5"
                    >
                      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                    </svg>
                  </button>
                </a>
                <a
                  href="https://youtube.com/ravish"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 w-10 rounded-full bg-red-600 text-white hover:opacity-90">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-youtube h-5 w-5"
                    >
                      <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17" />
                      <path d="m10 15 5-3-5-3z" />
                    </svg>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="lg:col-span-8 xl:col-span-9">
      <div className="bg-slate-800/50 backdrop-blur-lg rounded-xl border border-slate-700/50 shadow-lg mb-4 sticky top-2 z-30">
        <div className="relative">
          <div className="flex overflow-x-auto scrollbar-hide py-1 px-1 scroll-smooth">
            <div class="flex py-1 gap-1 md:gap-2">
                  <a href="#about" class="px-3 py-1.5 rounded-lg text-xs md:text-sm font-medium transition-all duration-200 flex-shrink-0 bg-primary text-white shadow-lg">About</a>
                  <a href="#services" class="px-3 py-1.5 rounded-lg text-xs md:text-sm font-medium transition-all duration-200 flex-shrink-0 text-slate-300 hover:bg-slate-700/50">Services</a>
                  <a href="#destinations" class="px-3 py-1.5 rounded-lg text-xs md:text-sm font-medium transition-all duration-200 flex-shrink-0 text-slate-300 hover:bg-slate-700/50">Destinations</a>
                  <a href="#gallery" class="px-3 py-1.5 rounded-lg text-xs md:text-sm font-medium transition-all duration-200 flex-shrink-0 text-slate-300 hover:bg-slate-700/50">Gallery</a>
                  <a href="#reviews" class="px-3 py-1.5 rounded-lg text-xs md:text-sm font-medium transition-all duration-200 flex-shrink-0 text-slate-300 hover:bg-slate-700/50">Reviews</a>
                  <a href="#chronicles" class="px-3 py-1.5 rounded-lg text-xs md:text-sm font-medium transition-all duration-200 flex-shrink-0 text-slate-300 hover:bg-slate-700/50">Chronicles</a>
              </div>
          </div>
          <div className="absolute right-0 top-0 bottom-0 w-6 bg-gradient-to-l from-slate-800/90 to-transparent pointer-events-none flex items-center justify-end pr-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-chevron-right h-3 w-3 text-white/60"
            >
              <path d="m9 18 6-6-6-6" />
            </svg>
          </div>
        </div>
      </div>
      <section
        id="about"
        className="mb-4 bg-slate-800/30 backdrop-blur-sm rounded-xl p-3 md:p-8 border border-slate-700/50 shadow-lg"
      >
        <div className="flex items-center gap-2 mb-3">
          <div className="h-8 w-8 rounded-lg bg-primary/20 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-users h-4 w-4 text-primary"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx={9} cy={7} r={4} />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <h2 className="text-lg md:text-2xl font-bold text-white">
            About Ravish Jha
          </h2>
        </div>
        <div className="relative">
          <div className="absolute -top-6 -left-6 w-20 h-20 rounded-full bg-primary/10 blur-xl pointer-events-none" />
          <p className="text-sm md:text-base text-slate-300 leading-relaxed relative z-10">
            Travel enthusiast with over 4 years of experience guiding travelers
            through the cultural wonders of India. Specializing in historical
            tours, food experiences, and off-the-beaten-path adventures. I
            believe in creating authentic travel experiences that connect you
            with local culture and people. My goal is to help you discover the
            real India beyond the tourist spots.
          </p>
        </div>
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6">
          <div className="bg-slate-800/50 rounded-xl p-3 md:p-6 border border-slate-700/50">
            <h3 className="font-semibold text-white mb-2 md:mb-4 flex items-center text-sm md:text-base">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-award h-4 w-4 text-primary mr-2"
              >
                <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
                <circle cx={12} cy={8} r={6} />
              </svg>
              Expertise
            </h3>
            <div className="grid grid-cols-2 gap-2">
              <div className="flex items-center gap-1.5">
                <div className="h-5 w-5 rounded-full bg-primary/20 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check h-2.5 w-2.5 text-primary"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                </div>
                <span className="text-xs md:text-sm text-slate-300">
                  Historical Tours
                </span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="h-5 w-5 rounded-full bg-primary/20 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check h-2.5 w-2.5 text-primary"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                </div>
                <span className="text-xs md:text-sm text-slate-300">
                  Food Experiences
                </span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="h-5 w-5 rounded-full bg-primary/20 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check h-2.5 w-2.5 text-primary"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                </div>
                <span className="text-xs md:text-sm text-slate-300">
                  Cultural Immersion
                </span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="h-5 w-5 rounded-full bg-primary/20 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check h-2.5 w-2.5 text-primary"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                </div>
                <span className="text-xs md:text-sm text-slate-300">
                  Photography
                </span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="h-5 w-5 rounded-full bg-primary/20 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check h-2.5 w-2.5 text-primary"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                </div>
                <span className="text-xs md:text-sm text-slate-300">
                  Budget Travel
                </span>
              </div>
            </div>
          </div>
          <div className="bg-slate-800/50 rounded-xl p-3 md:p-6 border border-slate-700/50">
            <h3 className="font-semibold text-white mb-2 md:mb-4 flex items-center text-sm md:text-base">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-sparkles h-4 w-4 text-primary mr-2"
              >
                <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                <path d="M20 3v4" />
                <path d="M22 5h-4" />
                <path d="M4 17v2" />
                <path d="M5 18H3" />
              </svg>
              Highlights
            </h3>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <div className="h-6 w-6 rounded-full bg-primary/20 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-compass h-3 w-3 text-primary"
                  >
                    <circle cx={12} cy={12} r={10} />
                    <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
                  </svg>
                </div>
                <div>
                  <p className="text-white font-medium text-xs md:text-sm">
                    Expert Guide
                  </p>
                  <p className="text-xs text-slate-400">
                    Specialized in cultural experiences
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="h-6 w-6 rounded-full bg-primary/20 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-utensils h-3 w-3 text-primary"
                  >
                    <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
                    <path d="M7 2v20" />
                    <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" />
                  </svg>
                </div>
                <div>
                  <p className="text-white font-medium text-xs md:text-sm">
                    Food Connoisseur
                  </p>
                  <p className="text-xs text-slate-400">
                    Discover authentic local cuisine
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="h-6 w-6 rounded-full bg-primary/20 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-camera h-3 w-3 text-primary"
                  >
                    <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
                    <circle cx={12} cy={13} r={3} />
                  </svg>
                </div>
                <div>
                  <p className="text-white font-medium text-xs md:text-sm">
                    Photography Expert
                  </p>
                  <p className="text-xs text-slate-400">
                    Capture the perfect travel moments
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        id="services"
        className="mb-4 bg-slate-800/30 backdrop-blur-sm rounded-xl p-3 md:p-8 border border-slate-700/50 shadow-lg"
      >
        <div className="flex items-center gap-2 mb-3">
          <div className="h-8 w-8 rounded-lg bg-primary/20 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-briefcase h-4 w-4 text-primary"
            >
              <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
              <rect width={20} height={14} x={2} y={6} rx={2} />
            </svg>
          </div>
          <h2 className="text-lg md:text-2xl font-bold text-white">
            Services &amp; Experiences
          </h2>
        </div>
        <div className="relative">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <a
              href="/experts/profile/priya-malhotra/services/virtual-consultation"
              className="block "
            >
              <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg hover:shadow-xl transition-all duration-300 h-full">
                <div className="relative h-48">
                  <img
                    alt="Virtual Consultation"
                    loading="lazy"
                    decoding="async"
                    data-nimg="fill"
                    className="object-cover group-hover:scale-105 transition-transform duration-500"
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0,
                      color: "transparent"
                    }}
                    src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/delhi-hotel-arrival-34c785CBfWrblIjhsdj5YWESDBalwp.png"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-slate-900/30" />
                  <div className="absolute top-3 left-3 h-9 w-9 rounded-lg bg-primary/20 backdrop-blur-sm flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-message-square h-5 w-5"
                    >
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                    </svg>
                  </div>
                  <div className="absolute top-3 right-3">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary text-white border-none">
                      ₹1,500
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <h3 className="text-white font-bold text-lg mb-1">
                      Virtual Consultation
                    </h3>
                    <div className="flex items-center text-slate-300 text-sm">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-clock h-3.5 w-3.5 mr-1"
                      >
                        <circle cx={12} cy={12} r={10} />
                        <polyline points="12 6 12 12 16 14" />
                      </svg>
                      60 minutes
                    </div>
                  </div>
                </div>
                <div className="p-3">
                  <p className="text-slate-300 text-sm mb-3">
                    One-on-one video call to plan your perfect trip to India.
                    Includes personalized itinerary suggestions.
                  </p>
                  <div className="flex flex-wrap gap-1">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Personalized itinerary planning
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Local insights
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Budget optimization
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Follow-up support
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a
              href="/experts/profile/priya-malhotra/services/delhi-heritage-tour"
              className="block "
            >
              <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg hover:shadow-xl transition-all duration-300 h-full">
                <div className="relative h-48">
                  <img
                    alt="Delhi Heritage Tour"
                    loading="lazy"
                    decoding="async"
                    data-nimg="fill"
                    className="object-cover group-hover:scale-105 transition-transform duration-500"
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0,
                      color: "transparent"
                    }}
                    src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/red-fort-detail-qwMiht2skQTo2JvabkgqMiz6woW1wx.png"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-slate-900/30" />
                  <div className="absolute top-3 left-3 h-9 w-9 rounded-lg bg-primary/20 backdrop-blur-sm flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-compass h-5 w-5"
                    >
                      <circle cx={12} cy={12} r={10} />
                      <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
                    </svg>
                  </div>
                  <div className="absolute top-3 right-3">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary text-white border-none">
                      ₹3,500
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <h3 className="text-white font-bold text-lg mb-1">
                      Delhi Heritage Tour
                    </h3>
                    <div className="flex items-center text-slate-300 text-sm">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-clock h-3.5 w-3.5 mr-1"
                      >
                        <circle cx={12} cy={12} r={10} />
                        <polyline points="12 6 12 12 16 14" />
                      </svg>
                      Full day (8 hours)
                    </div>
                  </div>
                </div>
                <div className="p-3">
                  <p className="text-slate-300 text-sm mb-3">
                    Explore Delhi's rich history and architecture with a
                    knowledgeable guide.
                  </p>
                  <div className="flex flex-wrap gap-1">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Old &amp; New Delhi
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Monument entry fees included
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Transportation
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Lunch at local restaurant
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a
              href="/experts/profile/priya-malhotra/services/food-culture-experience"
              className="block "
            >
              <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg hover:shadow-xl transition-all duration-300 h-full">
                <div className="relative h-48">
                  <img
                    alt="Food & Culture Experience"
                    loading="lazy"
                    decoding="async"
                    data-nimg="fill"
                    className="object-cover group-hover:scale-105 transition-transform duration-500"
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0,
                      color: "transparent"
                    }}
                    src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/karims-delhi-spread-N83Em1W5gW4q33vaVwdVSvslJHV4wg.png"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-slate-900/30" />
                  <div className="absolute top-3 left-3 h-9 w-9 rounded-lg bg-primary/20 backdrop-blur-sm flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-utensils h-5 w-5"
                    >
                      <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
                      <path d="M7 2v20" />
                      <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" />
                    </svg>
                  </div>
                  <div className="absolute top-3 right-3">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary text-white border-none">
                      ₹2,500
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <h3 className="text-white font-bold text-lg mb-1">
                      Food &amp; Culture Experience
                    </h3>
                    <div className="flex items-center text-slate-300 text-sm">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-clock h-3.5 w-3.5 mr-1"
                      >
                        <circle cx={12} cy={12} r={10} />
                        <polyline points="12 6 12 12 16 14" />
                      </svg>
                      Half day (4 hours)
                    </div>
                  </div>
                </div>
                <div className="p-3">
                  <p className="text-slate-300 text-sm mb-3">
                    Taste the authentic flavors of Delhi while learning about
                    the cultural significance of each dish.
                  </p>
                  <div className="flex flex-wrap gap-1">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      6-8 food stops
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Small group (max 6)
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Cultural insights
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Digestive aids provided
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section
        id="destinations"
        className="mb-4 bg-slate-800/30 backdrop-blur-sm rounded-xl p-3 md:p-8 border border-slate-700/50 shadow-lg"
      >
        <div className="flex items-center justify-between gap-2 mb-3">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-lg bg-primary/20 flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-globe h-4 w-4 text-primary"
              >
                <circle cx={12} cy={12} r={10} />
                <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
                <path d="M2 12h20" />
              </svg>
            </div>
            <h2 className="text-lg md:text-2xl font-bold text-white">
              Destinations Visited
            </h2>
          </div>
          <div className="relative">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-search absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400"
            >
              <circle cx={11} cy={11} r={8} />
              <path d="m21 21-4.3-4.3" />
            </svg>
            <input
              className="flex border px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 pl-8 bg-slate-800/50 border-slate-700 text-white w-32 md:w-48 h-8 text-xs rounded-lg focus:border-primary"
              placeholder="Search destinations..."
              defaultValue=""
            />
          </div>
        </div>
        <div className="relative">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg hover:shadow-xl transition-all duration-300 ">
              <div className="relative h-48 md:h-56">
                <img
                  alt="Maldives"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/maldives-infinity-pool-GNrieUFZvfT2NsYmE5gDlpNZZdfBNj.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-slate-900/30" />
                <div className="absolute top-3 right-3">
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary/80 text-white border-none">
                    Beach
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="text-white font-bold text-lg">Maldives</h3>
                    <span className="text-xs text-slate-300">2023</span>
                  </div>
                  <p className="text-slate-300 text-xs line-clamp-2">
                    Explored the pristine beaches and underwater wonders of the
                    Maldives
                  </p>
                </div>
              </div>
            </div>
            <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg hover:shadow-xl transition-all duration-300 ">
              <div className="relative h-48 md:h-56">
                <img
                  alt="Cinque Terre"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/cinque-terre-clifftop-village-6bGH9ftbsrc95OSFNkFv4lpy0R2w2t.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-slate-900/30" />
                <div className="absolute top-3 right-3">
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary/80 text-white border-none">
                    Coastal
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="text-white font-bold text-lg">
                      Cinque Terre
                    </h3>
                    <span className="text-xs text-slate-300">2022</span>
                  </div>
                  <p className="text-slate-300 text-xs line-clamp-2">
                    This is my first trip to Cinque Terre, Italy. The colorful
                    coastal villages were absolutely breathtaking.
                  </p>
                </div>
              </div>
            </div>
            <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg hover:shadow-xl transition-all duration-300 ">
              <div className="relative h-48 md:h-56">
                <img
                  alt="Switzerland"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/alpine-majesty-PK8vhoa6BnqMSPsPawr5RE48EewAe3.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-slate-900/30" />
                <div className="absolute top-3 right-3">
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary/80 text-white border-none">
                    Mountains
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="text-white font-bold text-lg">
                      Switzerland
                    </h3>
                    <span className="text-xs text-slate-300">2022</span>
                  </div>
                  <p className="text-slate-300 text-xs line-clamp-2">
                    Explored the Swiss Alps and enjoyed the stunning mountain
                    landscapes and charming villages.
                  </p>
                </div>
              </div>
            </div>
            <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg hover:shadow-xl transition-all duration-300 ">
              <div className="relative h-48 md:h-56">
                <img
                  alt="Bangkok"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/Bangkok-Temple-Twilight-9wdr9iDE2X3H0MOswBETZg4JWlvmpk.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-slate-900/30" />
                <div className="absolute top-3 right-3">
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary/80 text-white border-none">
                    City
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="text-white font-bold text-lg">Bangkok</h3>
                    <span className="text-xs text-slate-300">2021</span>
                  </div>
                  <p className="text-slate-300 text-xs line-clamp-2">
                    Explored the vibrant street food scene and magnificent
                    temples of Bangkok.
                  </p>
                </div>
              </div>
            </div>
            <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg hover:shadow-xl transition-all duration-300 ">
              <div className="relative h-48 md:h-56">
                <img
                  alt="Rajasthan"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/majestic-rajasthani-palace-f5GyVylxkRSig5YmLdU1mBlhkNO1uR.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-slate-900/30" />
                <div className="absolute top-3 right-3">
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary/80 text-white border-none">
                    Cultural
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="text-white font-bold text-lg">Rajasthan</h3>
                    <span className="text-xs text-slate-300">2021</span>
                  </div>
                  <p className="text-slate-300 text-xs line-clamp-2">
                    Immersed in the rich cultural heritage and royal history of
                    Rajasthan's palaces and forts.
                  </p>
                </div>
              </div>
            </div>
            <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg hover:shadow-xl transition-all duration-300 ">
              <div className="relative h-48 md:h-56">
                <img
                  alt="Bali"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/bali-green-steps-KWYPWWoLATkrpEGVfBr4sO5HuS4t4E.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-slate-900/30" />
                <div className="absolute top-3 right-3">
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary/80 text-white border-none">
                    Tropical
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="text-white font-bold text-lg">Bali</h3>
                    <span className="text-xs text-slate-300">2020</span>
                  </div>
                  <p className="text-slate-300 text-xs line-clamp-2">
                    Experienced the spiritual side of Bali with its temples,
                    rice terraces, and beautiful beaches.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        id="gallery"
        className="mb-4 bg-slate-800/30 backdrop-blur-sm rounded-xl p-3 md:p-8 border border-slate-700/50 shadow-lg"
      >
        <div className="flex items-center gap-2 mb-3">
          <div className="h-8 w-8 rounded-lg bg-primary/20 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-camera h-4 w-4 text-primary"
            >
              <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
              <circle cx={12} cy={13} r={3} />
            </svg>
          </div>
          <h2 className="text-lg md:text-2xl font-bold text-white">
            Travel Gallery
          </h2>
        </div>
        <div className="relative">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg cursor-pointer aspect-square">
              <div className="relative h-full w-full">
                <img
                  alt="Exploring night markets in Thailand"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/bustling-bangkok-night-market-itsdSJZL3tHWQXZQiSzTE8kC445h5r.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="absolute bottom-0 left-0 right-0 p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-white text-sm">
                    Exploring night markets in Thailand
                  </p>
                </div>
              </div>
            </div>
            <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg cursor-pointer aspect-square">
              <div className="relative h-full w-full">
                <img
                  alt="Sunset views from the coast"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/serene-beach-read-bzoKOiA2wJjne2xVnmsP272eEt3Iew.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="absolute bottom-0 left-0 right-0 p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-white text-sm">
                    Sunset views from the coast
                  </p>
                </div>
              </div>
            </div>
            <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg cursor-pointer aspect-square">
              <div className="relative h-full w-full">
                <img
                  alt="Beach day in the Maldives"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/serene-beach-read-bzoKOiA2wJjne2xVnmsP272eEt3Iew.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="absolute bottom-0 left-0 right-0 p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-white text-sm">
                    Beach day in the Maldives
                  </p>
                </div>
              </div>
            </div>
            <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg cursor-pointer aspect-square">
              <div className="relative h-full w-full">
                <img
                  alt="Hiking in the Swiss Alps"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/winding-mountain-path-lfcHhJRoL2oy0zfrRHFtfq0tmz4qRJ.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="absolute bottom-0 left-0 right-0 p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-white text-sm">Hiking in the Swiss Alps</p>
                </div>
              </div>
            </div>
            <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg cursor-pointer aspect-square">
              <div className="relative h-full w-full">
                <img
                  alt="Ancient temples of Angkor Wat"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/serene-asian-temple-BJ70WpO2uy7LmTNntj2snprPuyS68P.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="absolute bottom-0 left-0 right-0 p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-white text-sm">
                    Ancient temples of Angkor Wat
                  </p>
                </div>
              </div>
            </div>
            <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg cursor-pointer aspect-square">
              <div className="relative h-full w-full">
                <img
                  alt="Sampling street food in Bangkok"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/bustling-asian-street-food-z6ehyapj15H9x8UQzIYP1l4U3P9zGb.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="absolute bottom-0 left-0 right-0 p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-white text-sm">
                    Sampling street food in Bangkok
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        id="reviews"
        className="mb-4 bg-slate-800/30 backdrop-blur-sm rounded-xl p-3 md:p-8 border border-slate-700/50 shadow-lg"
      >
        <div className="flex items-center gap-2 mb-3">
          <div className="h-8 w-8 rounded-lg bg-primary/20 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-star h-4 w-4 text-primary"
            >
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
          </div>
          <h2 className="text-lg md:text-2xl font-bold text-white">
            Traveler Reviews
          </h2>
        </div>
        <div className="space-y-4">
          <div className="bg-slate-800/50 rounded-xl p-3 md:p-6 border border-slate-700/50">
            <div className="flex items-start gap-3">
              <span className="relative flex shrink-0 overflow-hidden rounded-full h-10 w-10 border-2 border-slate-700">
                <span className="flex h-full w-full items-center justify-center rounded-full bg-slate-700 text-white">
                  P
                </span>
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-1">
                  <h3 className="font-medium text-white text-sm md:text-base truncate">
                    Priya Sharma
                  </h3>
                  <div className="flex items-center">
                    <div className="flex items-center text-amber-400">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                    </div>
                    <span className="text-xs text-slate-400 ml-2">
                      June 15, 2023
                    </span>
                  </div>
                </div>
                <div className="text-xs text-slate-400 mt-0.5">
                  Delhi Heritage Tour
                </div>
                <p className="text-slate-300 text-sm mt-2">
                  Ravish was an incredible guide for our Delhi tour. His
                  knowledge of history and culture made the experience so much
                  richer. He took us to hidden gems we would never have found on
                  our own!
                </p>
              </div>
            </div>
          </div>
          <div className="bg-slate-800/50 rounded-xl p-3 md:p-6 border border-slate-700/50">
            <div className="flex items-start gap-3">
              <span className="relative flex shrink-0 overflow-hidden rounded-full h-10 w-10 border-2 border-slate-700">
                <span className="flex h-full w-full items-center justify-center rounded-full bg-slate-700 text-white">
                  M
                </span>
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-1">
                  <h3 className="font-medium text-white text-sm md:text-base truncate">
                    Michael Chen
                  </h3>
                  <div className="flex items-center">
                    <div className="flex items-center text-amber-400">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                    </div>
                    <span className="text-xs text-slate-400 ml-2">
                      May 22, 2023
                    </span>
                  </div>
                </div>
                <div className="text-xs text-slate-400 mt-0.5">
                  Old Delhi Food Walk
                </div>
                <p className="text-slate-300 text-sm mt-2">
                  The food tour with Ravish was the highlight of our trip to
                  India. He knows all the best local spots and helped us
                  navigate the street food scene with confidence. Highly
                  recommend!
                </p>
              </div>
            </div>
          </div>
          <div className="bg-slate-800/50 rounded-xl p-3 md:p-6 border border-slate-700/50">
            <div className="flex items-start gap-3">
              <span className="relative flex shrink-0 overflow-hidden rounded-full h-10 w-10 border-2 border-slate-700">
                <span className="flex h-full w-full items-center justify-center rounded-full bg-slate-700 text-white">
                  S
                </span>
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-1">
                  <h3 className="font-medium text-white text-sm md:text-base truncate">
                    Sarah Johnson
                  </h3>
                  <div className="flex items-center">
                    <div className="flex items-center text-amber-400">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-slate-700"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                    </div>
                    <span className="text-xs text-slate-400 ml-2">
                      April 10, 2023
                    </span>
                  </div>
                </div>
                <div className="text-xs text-slate-400 mt-0.5">
                  North India Planning
                </div>
                <p className="text-slate-300 text-sm mt-2">
                  Ravish helped us plan our entire North India itinerary. His
                  suggestions were spot on and he was always available to answer
                  questions during our trip. Would definitely use his services
                  again.
                </p>
              </div>
            </div>
          </div>
          <div className="bg-slate-800/50 rounded-xl p-3 md:p-6 border border-slate-700/50">
            <div className="flex items-start gap-3">
              <span className="relative flex shrink-0 overflow-hidden rounded-full h-10 w-10 border-2 border-slate-700">
                <span className="flex h-full w-full items-center justify-center rounded-full bg-slate-700 text-white">
                  R
                </span>
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-1">
                  <h3 className="font-medium text-white text-sm md:text-base truncate">
                    Raj Patel
                  </h3>
                  <div className="flex items-center">
                    <div className="flex items-center text-amber-400">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                    </div>
                    <span className="text-xs text-slate-400 ml-2">
                      March 5, 2023
                    </span>
                  </div>
                </div>
                <div className="text-xs text-slate-400 mt-0.5">
                  Delhi Photography Tour
                </div>
                <p className="text-slate-300 text-sm mt-2">
                  As a photographer, I wanted to capture the real Delhi.
                  Ravish's photography tour took me to perfect spots at the
                  right time of day. His local insights were invaluable.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        id="chronicles"
        className="mb-4 bg-slate-800/30 backdrop-blur-sm rounded-xl p-3 md:p-8 border border-slate-700/50 shadow-lg"
      >
        <div className="flex items-center gap-2 mb-3">
          <div className="h-8 w-8 rounded-lg bg-primary/20 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-compass h-4 w-4 text-primary"
            >
              <circle cx={12} cy={12} r={10} />
              <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
            </svg>
          </div>
          <h2 className="text-lg md:text-2xl font-bold text-white">
            Travel Chronicles
          </h2>
        </div>
        <div className="relative">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <a
              href="/experts/profile/priya-malhotra/chronicles/1"
              className="block "
            >
              <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg hover:shadow-xl transition-all duration-300 h-full">
                <div className="relative h-48">
                  <img
                    alt="Haridwar-Rishikesh-Mussoorie: North India Budget Tour Package"
                    loading="lazy"
                    decoding="async"
                    data-nimg="fill"
                    className="object-cover group-hover:scale-105 transition-transform duration-500"
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0,
                      color: "transparent"
                    }}
                    src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/rishikesh-himalayan-vista-fLAiD9JdAsuY7yksOTY6BfErbpO5It.png"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-slate-900/30" />
                  <div className="absolute top-3 right-3">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary/80 text-white border-none">
                      May 15, 2023
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <h3 className="text-white font-bold text-lg line-clamp-2">
                      Haridwar-Rishikesh-Mussoorie: North India Budget Tour
                      Package
                    </h3>
                  </div>
                </div>
                <div className="p-3">
                  <p className="text-slate-300 text-sm mb-3 line-clamp-3">
                    You aren't going to believe the trip I just had! Exploring
                    the spiritual cities of Haridwar and Rishikesh, followed by
                    the beautiful hill station of Mussoorie.
                  </p>
                  <div className="flex flex-wrap gap-1">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Budget-friendly
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Spiritual journey
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Mountain views
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a
              href="/experts/profile/priya-malhotra/chronicles/2"
              className="block "
            >
              <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg hover:shadow-xl transition-all duration-300 h-full">
                <div className="relative h-48">
                  <img
                    alt="Bangkok & Pattaya: The Perfect 5-Day Itinerary"
                    loading="lazy"
                    decoding="async"
                    data-nimg="fill"
                    className="object-cover group-hover:scale-105 transition-transform duration-500"
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0,
                      color: "transparent"
                    }}
                    src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/bangkok-night-skyline-vpEP3rGo87FAPHNqRLq24pxxX2rwQd.png"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-slate-900/30" />
                  <div className="absolute top-3 right-3">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary/80 text-white border-none">
                      March 10, 2023
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <h3 className="text-white font-bold text-lg line-clamp-2">
                      Bangkok &amp; Pattaya: The Perfect 5-Day Itinerary
                    </h3>
                  </div>
                </div>
                <div className="p-3">
                  <p className="text-slate-300 text-sm mb-3 line-clamp-3">
                    My comprehensive guide to exploring Bangkok and Pattaya in
                    just 5 days, covering all the must-visit attractions and
                    hidden gems.
                  </p>
                  <div className="flex flex-wrap gap-1">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      City exploration
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Beach getaway
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Nightlife
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a
              href="/experts/profile/priya-malhotra/chronicles/3"
              className="block "
            >
              <div className="group relative rounded-xl overflow-hidden border border-slate-700/50 shadow-lg hover:shadow-xl transition-all duration-300 h-full">
                <div className="relative h-48">
                  <img
                    alt="Backpacking Through Europe: A 3-Week Adventure"
                    loading="lazy"
                    decoding="async"
                    data-nimg="fill"
                    className="object-cover group-hover:scale-105 transition-transform duration-500"
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0,
                      color: "transparent"
                    }}
                    src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/european-rail-adventure-VLUt5QTMIImKTYsd3tuhUM3lyX2Uzu.png"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-slate-900/30" />
                  <div className="absolute top-3 right-3">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary/80 text-white border-none">
                      September 5, 2022
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <h3 className="text-white font-bold text-lg line-clamp-2">
                      Backpacking Through Europe: A 3-Week Adventure
                    </h3>
                  </div>
                </div>
                <div className="p-3">
                  <p className="text-slate-300 text-sm mb-3 line-clamp-3">
                    Join me as I share my experiences backpacking through
                    multiple European countries on a budget, with tips for
                    fellow travelers.
                  </p>
                  <div className="flex flex-wrap gap-1">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Budget travel
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Multi-country
                    </div>
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 bg-slate-700/50 text-white border-slate-600 text-xs">
                      Cultural immersion
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>

</main>

      <Footer />
    </>
  );
};

export default ExpertsDtl;
